import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import devias from './devias/index'

export const theme = createMuiTheme(devias);